
const underconstruction = [
    {
        "key": "underconstruction.title",
        "string": "Work in progress"
    },
    {
        "key": "underconstruction.text",
        "string": "Please be aware that this website is still work in progress. More content will be added soon."
    }
]

export default underconstruction



// WEBPACK FOOTER //
// ./src/i18n/en/landingpage/underconstruction.js